import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import useUserProfiles from "./useUserProfiles";
import { useCallback, useMemo } from "react";

const useFitnessProfileSettings = () => {
  const { userProfilesData, userProfilesError, userProfilesIsLoading, updateUserProfiles } =
    useUserProfiles();

  const updateSelectedFitnessProfiles = useCallback(
    async (fitnessProfileSelection: WahooWorkoutTypeFamily[]) => {
      updateUserProfiles({
        workoutTypeFamilyPreferences: fitnessProfileSelection,
      });
    },
    [updateUserProfiles]
  );

  const selectedFitnessProfiles = useMemo(() => {
    return userProfilesData?.workout_type_family_preferences?.length
      ? userProfilesData.workout_type_family_preferences
      : [WahooWorkoutTypeFamily.Cycling, WahooWorkoutTypeFamily.Running];
  }, [userProfilesData]);

  return {
    selectedFitnessProfiles,
    updateSelectedFitnessProfiles,
    error: userProfilesError,
    isLoading: userProfilesIsLoading,
  };
};

export default useFitnessProfileSettings;
